<template>

	<v-content>
		<v-container fluid  >
			<div class="TeklifOffers">

				<template v-if="isLoading">
					<div class="text-xs-center pa-5">
						<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
						<div class="caption mt-4">Ürün listesi yükleniyor</div>
					</div>
				</template>
				<div class="TeklifOffersTitle">
					Teklifler
					<div class="TeklifOffersActions">
						<v-btn   color="teal" class="newOfferButton mr-3" round outline @click="filters.show = !filters.show">Filtre</v-btn>
						<v-btn   color="primary" class="newOfferButton" round outline href="/teklif/offers/offer/" target="_blank">Yeni Teklif</v-btn>
					</div>
					
					
				</div>


				<div class="TeklifOffersFilters" v-show="filters.show">
					<v-text-field outline label="Teklif Başlığı" v-model="filters.title" hide-details class="filtre-title"></v-text-field>

							<v-select outline v-model="filters.customer_id" :items="customers" item-text="company" item-value="id" hide-details label="Müşteri Adı" class="filtre-customer_id">

									<template slot="selection" slot-scope="data"> 
										<div class="tekifEditCustomerBox">
											<span class="tekifEditCustomerCompany">{{ data.item.company }}</span>
											<span class="tekifEditCustomerFullname">{{ data.item.fullname }}</span>
										</div> 
									</template>
									<template slot="item" slot-scope="data"> 
										<div class="tekifEditCustomerBox">
											<span class="tekifEditCustomerCompany">{{ data.item.company }}</span>
											<span class="tekifEditCustomerFullname">{{ data.item.fullname }}</span>
										</div> 
									</template>

								</v-select>
 
					<v-select v-model="filters.goruldu" :items="filtres_fields_goruldu" class="filtre-goruldu" hide-details label="Görülme Durumu" outline ></v-select>
					<v-select v-model="filters.onaylandi" :items="filtres_fields_onaylandi" class="filtre-onaylandi" hide-details label="Olay Durumu" outline ></v-select>
					<!-- <v-text-field outline label="Düzenleme Tarihi" v-model="filters.date_edit" hide-details class="filtre-date_edit"></v-text-field>
					<v-text-field outline label="Fiyat Min" v-model="filters.genel_toplam_min" hide-details class="filtre-genel_toplam_min"></v-text-field>
					<v-text-field outline label="Fiyat Max" v-model="filters.genel_toplam_max" hide-details class="filtre-genel_toplam_max"></v-text-field> -->
				</div>


				<div class="TeklifOffersBody">
					<v-data-table 
						:headers="tableHeaders" 
						:items="getItems" 
						:rows-per-page-items="['10']" 
						rows-per-page-text="Sayfa başı" 
						class="elevation-1"
					>
						<template slot="items" scope="line">
							<td>
								{{ line.item.id }}
							</td>
							<td>
								<a @click.prevent="editOffer(line.item)">{{ line.item.title }}</a>
							</td>
							<td v-if="getCustomers[line.item.customer_id]">
								<div class="customerName">
									{{ getCustomers[line.item.customer_id]["company"] }}
								</div>
								<div class="customerEmail">
									{{ getCustomers[line.item.customer_id].fullname }}
								</div>
							</td> <td v-if="!getCustomers[line.item.customer_id]"></td>
							<td class="text-xs-right">
								<b v-if="line.item.version_id > 1">{{ line.item.version_id }}</b>
								<small v-if="line.item.version_id == 1">{{ line.item.version_id }}</small>
							</td>
							<td class="text-xs-right">
								<b class="green--text" v-if="line.item.goruldu == 1">Görüldü</b>
								<span class="grey--text" v-if="line.item.goruldu == 0">Bekliyor</span>
							</td> 
							<td class="text-xs-right"> 
								<b class="green--text" v-if="line.item.onaylandi == 1">Onaylandı</b>
								<span class="grey--text" v-if="line.item.onaylandi == 0">Bekliyor</span>
							</td> 
							<td class="OffersButtons">
								<v-btn small color="warning" round outline @click="askForCopy(line.item)">Kopyala</v-btn>
								<v-btn small color="error" round outline @click="askForRemove(line.item)">Sil</v-btn> 
							</td> 
						</template>
					</v-data-table>
				</div>

			</div>


				<v-dialog v-model="dialogEditor" persistent max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline">Çoğalt</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap>
									<v-flex xs12>
										<v-text-field label="Teklif Başlığı" v-model="willCopyItem.title"></v-text-field>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4">
							<v-btn color="warning" round outline @click="closeForCopy()">İptal</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="success" round outline @click="copyItem()">Kopyala</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



				<v-dialog v-model="dialogRemove" persistent  max-width="290">
					<v-card> 
						<v-card-text color="error"> Silmek itediğine emin misin ? </v-card-text> 
						<v-card-actions> 
							<v-btn color="green darken-1" flat="flat" @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" flat="flat" @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>






		</v-container>
	</v-content>


</template>


<script>
	import FloatSpan from "@/components/tools/FloatSpan.vue";
	import FloatInput from "@/components/tools/FloatInput.vue";
	export default {
		name: "TeklifOffers",
		components: {
			FloatSpan,
			FloatInput,
		},
		data() {
			return {
				isLoading: true,
				dialogEditor: false,
				dialogRemove: false,
				filterText: "",
				categories: [],
				customers: [],
				items: [],
				willRemoveItem : {},
				willCopyItem : {},
				filters : {
					show : false,
					title : "",
					customer_id : "", 
					goruldu : "",
					onaylandi : "",
					date_edit : "",
					genel_toplam_min : "",
					genel_toplam_max : "", 
				},
				filtres_fields_goruldu : ["Tümü","Görüldü","Bekliyor"],
				filtres_fields_onaylandi : ["Tümü","Onaylandı","Bekliyor"],

				tableHeaders: [
					{
						text: 'No',
						value: 'No',
						width : 10
					},
					{
						text: 'Teklif Başlığı',
						align: 'left', 
						value: 'title'
					},
					{
						text: 'Firma',
						value: 'customer_name'
					},
					{
						text: 'Version',
						value: 'version_id',
						align: 'right',
						width : 100
					},
					{
						text: 'Görüldü',
						value: 'goruldu',
						align: 'right',
						width : 100
					},
					{
						text: 'Onaylandı',
						value: 'onaylandi',
						align: 'right',
						width : 100
					},
					{
						text: '#',
						value: '',
						align: 'right',
						width : 160
					},
				]
			}
		},
		mounted() {
			this.isLoading = true;
			// this.loadCategories();
			this.loadCustomers();
			this.loadItems(); 
		},
		methods: {
			loadCustomers() { 
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/customers/", {
					params: {}
				}).then(response => {
					this.customers = response.body; 
					this.customers.unshift({
						company : 'Tümü',
						id : ''
					})
				})
			}, 
			loadItems() {
				this.isLoading = true;
				this.dialogEditor = false;
				this.dialogRemove = false;
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/offers/", {
					params: {}
				}).then(response => {
					this.items = response.body;
					this.isLoading = false;
				})
			},
			newOffer(){
				this.$router.push("/teklif/offers/offer")
			},
			editOffer(offer){
				window.open("/teklif/offers/offer/?id="+offer.id); 
			},

			askForRemove(item){
				this.willRemoveItem = item;
				this.dialogRemove = true;
			},
			closeForRemove(){
				this.dialogRemove = false;
			},
			removeItem(){
				this.isLoading = true;
				this.dialogRemove = false;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/offers/remove", this.willRemoveItem, {
					params: { }
				}).then(response => { 
					this.loadItems()
				})
			},

			askForCopy(item){
				this.willCopyItem = JSON.parse( JSON.stringify(item) );
				this.willCopyItem.title += " Kopyası";
				this.dialogEditor = true;
			},
			closeForCopy(){
				this.dialogEditor = false;
			},
			copyItem(){
				this.dialogEditor = false;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/offers/copy", this.willCopyItem, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
		},
		computed: {
			getCustomers(){
				var list = { };
				for(var i in this.customers){
					list[ this.customers[i].id.toString() ] = this.customers[i]
				}
				return list;
			},
			getItems() {
				var items = [];
				// var filterText = this.filterText.toLowerCase();
				var filters = this.filters;
				items = this.items.filter(function (item) {
					if(filters.show){
						if(filters.title != ""){
							if( item.title.toLowerCase().indexOf( filters.title.toLowerCase() ) < 0 ){
								return false;
							}
						}
						if(filters.customer_id != ""){
							if( item.customer_id != filters.customer_id ){
								return false;
							}
						} 
						if(filters.goruldu != "" || filters.goruldu != "Tümü"){
							if( filters.goruldu == "Görüldü" && item.goruldu != 1 ){
								return false;
							}
							if( filters.goruldu == "Bekliyor" && item.goruldu != 0 ){
								return false;
							}
						}
						if(filters.onaylandi != "" || filters.onaylandi != "Tümü"){
							if( filters.onaylandi == "Onaylandı" && item.onaylandi != 1 ){
								return false;
							}
							if( filters.onaylandi == "Bekliyor" && item.onaylandi != 0 ){
								return false;
							}
						} 
					}
					// if (filterText != "") {
					// 	if ( item.name.toLowerCase().indexOf(filterText) < 0 ) {
					// 		return false;
					// 	}
					// }
					return true;
				})
				// for(var i in items){
				// 	for(var c in this.categories){
				// 		if(this.categories[c].id == items[i].id_categorie){
				// 			items[i].categorie_name = this.categories[c].name;
				// 		}
				// 	}
				// }
				// items.sort(function (a, b) {
				// 	var nameA = a.name.toUpperCase();
				// 	var nameB = b.name.toUpperCase();
				// 	if (nameA < nameB) { return -1; }
				// 	if (nameA > nameB) { return 1; }
				// 	return 0;
				// });
				return items;
			},
		}
	}
</script>

<style lang="less">
	.TeklifOffers {
		width: 100%;

		.TeklifOffersTitle {
			background-color: #fff;
			padding: 15px;
			font-weight: 600;
			position: relative;
			box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important;
			z-index:1;
			.TeklifOffersActions{
				position: absolute;
				right : 6px;
				top : 6px;
			}
			.newOfferButton{ 
				margin:0px; 
				.v-btn__content{
					text-transform: none !important;
				}
			}
		}
		.TeklifOffersFilters{
			border-top:1px solid #ccc;
			padding : 20px;
			background-color: #fff;
			box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important;
			position: relative;
			z-index:2;
			.v-input{

			}
			.filtre-title,
			.filtre-customer_id,
			.filtre-customer_name,
			.filtre-customer_email{
				width : calc(~"33.3333% - 10px");
				margin:5px;
				float:left;
			}
			.filtre-date_edit,
			.filtre-genel_toplam_min,
			.filtre-genel_toplam_max{
				width : calc(~"33.3333% - 10px");
				margin:5px;
				float:left;
			}
			.filtre-genel_toplam_min,
			.filtre-genel_toplam_max{
				width : calc(~"33.3333% / 2 - 10px");
				margin:5px;
				float:left;
			}
			.filtre-goruldu,
			.filtre-onaylandi{
				width : calc(~"33.3333% / 2 - 10px");
				margin:5px;
				float:left;
			}
			&::after{
				content: '';
				display: table;
				clear:both;
			}
		}

 

		.TeklifOffersBody {
			position: relative;
			z-index:3;
			.customerName{
				font-weight: 500
			}
			.OffersPrice{
				font-weight: 500
			}
			.OffersButtons{
				padding-right : 5px;
				text-align: right;
				button{
					margin: 0px 2px;
					display: inline-block;
					min-width: 10px;
					padding: 0px 10px;
					.v-btn__content{
						text-transform: none !important;
					}
				}
			}
		}
	}
</style>